"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Runtime_1 = require("../types/Runtime");
const evaluateObjectOfEntryVars_1 = __importDefault(require("../shared/evaluateObjectOfEntryVars"));
const writeFunctionOutputToRegistry_1 = __importDefault(require("../shared/writeFunctionOutputToRegistry"));
const evaluateEntryVars = async ({ controlCallerId, entryVarsDefinition, processor, lastFunctionsOutputs, eventOutputs, }) => {
    if (!entryVarsDefinition) {
        return {};
    }
    const evaluateEntryVar = processor.evaluateVarFactory({
        controlCallerId,
        lastFunctionsOutputs,
        eventOutputs,
    });
    return (0, evaluateObjectOfEntryVars_1.default)({
        evaluator: evaluateEntryVar,
        entryVarsObject: entryVarsDefinition,
    });
};
const executeProcessesFactory = ({ store, processor, controlCallerId, eventOutputs, lastFunctionsOutputs: originalLastFunctionOutputs, }) => async (newFunctionOutId, processes, newFunctionOutValue) => {
    if (!processes) {
        return;
    }
    let lastFunctionsOutputs = originalLastFunctionOutputs;
    if (newFunctionOutId) {
        lastFunctionsOutputs = (0, writeFunctionOutputToRegistry_1.default)(lastFunctionsOutputs, newFunctionOutId, newFunctionOutValue);
    }
    for (let i = 0; i < processes.length; i += 1) {
        const currentProcess = processes[i];
        const entryVars = await evaluateEntryVars({
            controlCallerId,
            entryVarsDefinition: currentProcess.entryVarsDefinition,
            processor,
            lastFunctionsOutputs,
            eventOutputs,
        });
        const functionResult = await currentProcess.call({
            store,
            controlCallerId,
            functionId: currentProcess.functionId,
            callbacks: currentProcess.callbacks || Runtime_1.EMTPY_CALLABLE_CALLBACKS,
            callbacksDefinition: currentProcess.callbacksDefinition,
            // The api module definition if is an api module call
            moduleDefinition: currentProcess.moduleDefinition,
            extraFunctionDefinitions: currentProcess.extraFunctionDefinitions,
            lastFunctionsOutputs,
            entryVars,
            processor,
            eventOutputs,
            executeProcesses: executeProcessesFactory({
                store,
                processor,
                controlCallerId,
                eventOutputs,
                lastFunctionsOutputs,
            }),
        });
        // If the function returns something, means is sync
        // so its value gets passet to the next functions
        if (functionResult !== undefined && functionResult !== null) {
            lastFunctionsOutputs = (0, writeFunctionOutputToRegistry_1.default)(lastFunctionsOutputs, currentProcess.functionId, functionResult);
        }
    }
};
exports.default = executeProcessesFactory;
